import { Box, Button, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { MdErrorOutline, MdInsights } from "react-icons/md";

const messageCardSx: SxProps<Theme> = {
  marginTop: "12px",
  borderRadius: "30px",
  background: (theme) => theme.palette.common.white,
  padding: "4rem 2rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "1rem",
  minHeight: "280px",
};

type AnalyticsMessageProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
};

const AnalyticsMessage = ({
  icon,
  title,
  description,
  action,
}: AnalyticsMessageProps) => (
  <Box sx={messageCardSx}>
    {icon}
    <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#161447" }}>
      {title}
    </Typography>
    {description && (
      <Typography
        sx={{ fontSize: "15px", color: "#5C5A74", maxWidth: "420px" }}
      >
        {description}
      </Typography>
    )}
    {action}
  </Box>
);

/** Shown when no bot / organization is selected */
export const NoScopeState = () => {
  const { t } = useTranslation();
  return (
    <AnalyticsMessage
      icon={<MdInsights size={44} color="#1DA5AB" />}
      title={t("analytics.noScopeTitle")}
      description={t("analytics.noScopeDescription")}
    />
  );
};

/** Error card */
export const TabErrorState = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();
  return (
    <AnalyticsMessage
      icon={<MdErrorOutline size={44} color="#EE4242" />}
      title={t("analytics.errorTitle")}
      description={t("analytics.errorDescription")}
      action={
        <Button
          variant="contained"
          onClick={onRetry}
          sx={{
            textTransform: "none",
            borderRadius: "999px",
            paddingX: "1.5rem",
          }}
        >
          {t("common.tryAgain")}
        </Button>
      }
    />
  );
};
